import { render, staticRenderFns } from "./OATop.vue?vue&type=template&id=039d8bd5&"
import script from "./OATop.vue?vue&type=script&lang=js&"
export * from "./OATop.vue?vue&type=script&lang=js&"
import style0 from "./OATop.vue?vue&type=style&index=0&id=039d8bd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports